export { default } from '@klokhuis/modules/Commons/pages/About/About.page';
